import { Flex } from "@chakra-ui/react";
import { OrganizationProfile } from "@clerk/clerk-react";

import { useAppState } from "~/hooks/useAppState";
import Meta from "~/layout/Meta";

const AdminPage = () => {
  const { userInfo, hasOrg } = useAppState("userInfo", "hasOrg");

  if (!userInfo) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Meta title="Admin" />
      <Flex align={["top", "top"]}>
        {hasOrg && <OrganizationProfile />}
        {!hasOrg && (
          <div>
            <p>You're not in the admin organization. Use the Clerk admin page or direct db access to manage users.</p>
          </div>
        )}
      </Flex>
    </>
  );
};

export default AdminPage;
